import React, { useContext, useState } from "react";
import {
    BrowserRouter as Routers,
    Route,
    Routes,
    Navigate
} from "react-router-dom";

import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import CreateAccount from "./pages/CreateAccount";
import { AuthProvider, AuthContext } from "./Contexts/auth";
import People from "./pages/People";
import Analytics from "./pages/Analytics"
import UserCalendar from "./pages/UserCalendar";
import CostSpreadsheet from "./pages/HourlyCostSpreadsheet";
import CostPanel from "./pages/FixedCost";
import LoadingIndicator from "Components/LoadingIndicator/LoadingIndicator";
import SupplierProducts from "./pages/Suppliers";
import ProductsOperations from "./pages/ProductsOperations";
import ProductionBalancing from "./pages/Production";
import Configuration from "./pages/Configuration";
import Chatbot from "./pages/ChatBotIA/Chatbot";
import { useEffect } from "react";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import Panels from "pages/Panels/Panels";
import NoScreensAllowed from "pages/NoScreensAllowed/NoScreensAllowed";
import { ChatbotProvider } from "./Contexts/ChatbotContext";
import Home from "pages/home/Home";

const AppRoutes = () => {
    const Private = ({ children }) => {
        const { authenticated, loading } = useContext(AuthContext);
        const [allowedScreens, setAllowedScreens] = useState(() => {
            let storedScreens = localStorage.getItem("allowedScreens")
            return !storedScreens || storedScreens.length === 0 ? null : JSON.parse(storedScreens);
        });

        useEffect(() => {
            const fetchAllowedScreens = async () => {
                try {
                    const response = await ExecuteAxios.api('get', '/profile-screens/get-profile-screens-ids-by-profile/');
                    if (response && response.length > 0) {
                        setAllowedScreens(response);
                        localStorage.setItem("allowedScreens", JSON.stringify(response));
                    } else {
                        setAllowedScreens([]);
                    }
                } catch (error) {
                    console.error("Erro ao buscar telas permitidas:", error);
                    setAllowedScreens([]);
                }
            };

            if (authenticated && !allowedScreens) {
                fetchAllowedScreens();
            }
        }, [authenticated]);

        if (authenticated === false) {
            return <Navigate to="/login" />;
        }

        if (loading || allowedScreens === null) {
            return (
                <div className="loading">
                    <LoadingIndicator loaded={false} colorSpinner={'#ffffff'} />
                </div>
            )
        }

        const url = window.location.href;
        const parts = url.split('/');
        const lastPart = parts[parts.length - 1];
        if (lastPart !== '') {
            return children;
        }

        if (allowedScreens.length > 0) {
            const priorityIds = [2, 3, 4, 5, 6, 7, 8, 9, 1];

            const targetScreen = priorityIds
                .map(id => allowedScreens.find(screen => screen.id === id))
                .find(screen => screen !== undefined);

            if (targetScreen?.path && allowedScreens.length > 0) {
                return <Navigate to={targetScreen.path} />;
            }

            return <Navigate to="/not-found" />;
        } else {
            return <Navigate to="/no-screens-allowed" />;
        }
    };

    return (
        <Routers>
            <AuthProvider>
                <ChatbotProvider>
                    <Routes>
                        <Route exact path="/login" element={<Login />} />
                        <Route exact path="/forgot-password" element={<ChangePassword />} />
                        <Route exact path="/create-account" element={<CreateAccount />} />
                        <Route exact path="/panels" element={<Private><Panels /></Private>} />
                        <Route exact path="/suppliers" element={<Private><SupplierProducts /></Private>} />
                        <Route exact path="/products" element={<Private><ProductsOperations /></Private>} />
                        <Route exact path="/no-screens-allowed" element={<Private><NoScreensAllowed /></Private>} />
                        <Route exact path="/configuration" element={<Private><Configuration /></Private>} />
                        <Route exact path="/production" element={<Private><ProductionBalancing /></Private>} />
                        <Route exact path="/spreadsheet" element={<Private><CostSpreadsheet /></Private>} />
                        <Route exact path="/chatbot" element={<Private><Chatbot /></Private>} />
                        <Route exact path="/panel-cost" element={<Private><CostPanel /></Private>} />
                        <Route exact path="/" element={<Home />} />
                        <Route exact path="/user-calendar" element={<Private><UserCalendar /></Private>} />
                        <Route exact path="/analytics" element={<Private><Analytics /></Private>} />
                        <Route exact path="/people" element={<Private><People /></Private>} />
                    </Routes>
                </ChatbotProvider>
            </AuthProvider>
        </Routers>
    )
}

export default AppRoutes;
